import React from "react";

function SelectionCheckbox({ isSelected, onChange }) {
  return (
    <div
      role="checkbox"
      aria-checked={!!isSelected}
      className="d-inline-flex align-items-center justify-content-center cursor-pointer"
      style={{ cursor: "pointer", userSelect: "none", verticalAlign: "middle" }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        if (onChange) onChange();
      }}
    >
      <span
        style={{
          width: "18px",
          height: "18px",
          borderRadius: "4px",
          border: isSelected ? "2px solid #3699FF" : "2px solid #B5B5C3",
          backgroundColor: isSelected ? "#3699FF" : "#ffffff",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "all 0.15s ease-in-out",
          boxSizing: "border-box",
        }}
      >
        {isSelected && (
          <svg
            width="11"
            height="9"
            viewBox="0 0 11 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 4.5L4 7.5L10 1.5"
              stroke="#ffffff"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </span>
    </div>
  );
}

function groupingItemOnSelect(props) {
  const { ids = [], setIds, customerId } = props;
  if (ids.some((id) => id === customerId)) {
    setIds(ids.filter((id) => id !== customerId));
  } else {
    setIds([...ids, customerId]);
  }
}

function groupingAllOnSelect(props) {
  const { isSelected, setIds, entities } = props;
  if (!isSelected) {
    const allIds = [];
    if (Array.isArray(entities)) {
      entities.forEach((el) => {
        if (el && el.id !== undefined && el.id !== null) {
          allIds.push(el.id);
        }
      });
    }
    setIds(allIds);
  } else {
    setIds([]);
  }
  return !isSelected;
}

// check official documentations: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html?selectedKind=Row%20Selection&selectedStory=Custom%20Selection%20Column%20Header%20Style&full=0&addons=1&stories=1&panelRight=0&addonPanel=storybook%2Factions%2Factions-panel
export function getSelectRow(props) {
  const { entities, ids = [], setIds } = props;
  const isAllSelected =
    entities &&
    entities.length > 0 &&
    ids.length > 0 &&
    entities.every((el) => ids.includes(el.id));

  return {
    mode: "checkbox",
    clickToSelect: true,
    hideSelectAll: false,
    selected: ids,
    onSelect: (row, isSelect) => {
      groupingItemOnSelect({ ids, setIds, customerId: row.id });
    },
    onSelectAll: (isSelect, rows) => {
      groupingAllOnSelect({ isSelected: !isSelect, setIds, entities });
    },
    selectionHeaderRenderer: () => {
      const props = { isSelected: isAllSelected, entities, setIds };
      return (
        <SelectionCheckbox
          isSelected={isAllSelected}
          onChange={() => groupingAllOnSelect(props)}
        />
      );
    },
    selectionRenderer: ({ rowIndex }) => {
      if (!entities || !entities[rowIndex]) return null;
      const rowId = entities[rowIndex].id;
      const isSelected = ids.some((el) => el === rowId);
      const props = { ids, setIds, customerId: rowId };
      return (
        <SelectionCheckbox
          isSelected={isSelected}
          onChange={() => groupingItemOnSelect(props)}
        />
      );
    },
  };
}

